import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

import type { LenderApplicationsFilterEnum } from "@/features/common/enums";
import settings from "@/settings";

interface IFilterState {
  filters: LenderApplicationsFilterEnum[];
}

interface IFilterStore extends IFilterState {
  setFilters: (filters: LenderApplicationsFilterEnum[]) => void;
  clearFilters: () => void;
}
const initialState = {
  filters: settings.defaultFilters,
};

export const useFilterStore = createWithEqualityFn<IFilterStore>()(
  (set) => ({
    ...initialState,
    setFilters: (filters: LenderApplicationsFilterEnum[]) => set({ filters }),
    clearFilters: () => set(initialState),
  }),
  shallow,
);
